import React from 'react';
import { Globe } from 'lucide-react';
import { getSite, marketingUrl, platformName } from '../lib/site';

export default function SiteUnavailable() {
  const site = getSite();
  return (
    <div data-testid="site-unavailable" style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', background: '#0B0F19', color: '#F8FAFC', fontFamily: 'system-ui, sans-serif', padding: 24 }}>
      <div style={{ maxWidth: 520, textAlign: 'left' }}>
        <div style={{ width: 48, height: 48, borderRadius: 12, background: 'rgba(79,70,229,.15)', display: 'grid', placeItems: 'center', marginBottom: 24 }}><Globe size={24} color="#818CF8" /></div>
        <h1 style={{ fontSize: 28, fontWeight: 800, margin: '0 0 12px' }}>This address isn't connected yet</h1>
        <p style={{ color: '#94A3B8', lineHeight: 1.6, margin: '0 0 8px' }}>
          <code data-testid="site-unavailable-host" style={{ color: '#E2E8F0' }}>{site.host || window.location.host}</code> is not linked to any {platformName()} storefront.
          If you own this domain, connect it from your company settings and point its DNS at the platform.
        </p>
        <a href={marketingUrl()} data-testid="site-unavailable-home-link" style={{ color: '#818CF8', fontWeight: 600 }}>Go to {platformName()} →</a>
      </div>
    </div>
  );
}
